import { MetaInfo } from "@/components/meta-info"
import { useZeroWorkspace } from "@/lib/zero"
import { RoadmapSettings } from "../../app/roadmap/roadmap-settings"
import { SettingsHeader } from "../settings-header"
import { WeeklyRoadmapEmailSetting } from "./weekly-roadmap-email-setting"

export function RoadmapSettingsPage() {
	const workspace = useZeroWorkspace()

	return (
		<>
			<MetaInfo title="Feature requests Settings" />

			<SettingsHeader
				title="Feature requests"
				subtitle="Make your Linear requests publicly or privately available."
				docsArticle="bb5ca077-16c1-4d97-811e-c3107d2f1e87"
			/>
			<RoadmapSettings />
			{workspace && (
				<WeeklyRoadmapEmailSetting
					workspaceId={workspace.id}
					weeklyRoadmapEmailEnabled={workspace.weeklyRoadmapEmailEnabled}
				/>
			)}
		</>
	)
}
